// src/components/PrivateRoute.jsx
import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { getCurrentUser } from "../utils/authWrapper";
import { appUser } from "../utils/storageHelper";
import { sessionUser } from "../utils/storageHelper";

export default function PrivateRoutes({ children, userRoute = false }) {
  const user = userRoute ? sessionUser() : appUser(); // check sessionStorage for user routes

  if (!user) {
    return (
      <Navigate to={userRoute ? "/user/login-page" : "/login/admin"} replace />
    );
  }

  return children ? children : <Outlet />;
}
